
import React from "react";
import { Briefcase, ShoppingBag, Phone, Wrench } from "lucide-react";
import SlideLayout from "../components/SlideLayout";

const ProductLineupSlide = () => {
  return (
    <SlideLayout>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
        <div className="bg-white backdrop-blur-sm border border-indigo-400 p-8 rounded-lg hover:border-indigo-500 transition-all hover:bg-indigo-50 group shadow-md">
          <div className="flex items-center mb-4">
            <div className="bg-gradient-to-r from-indigo-600 to-purple-600 p-3 rounded-full mr-4">
              <Briefcase size={28} className="text-white" />
            </div>
            <h3 className="text-2xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-indigo-600 to-purple-600 group-hover:from-indigo-700 group-hover:to-purple-700 transition-colors font-cursive">Atelier</h3>
          </div>
          <p className="text-indigo-800 font-cursive">Premium enterprise AI solution for retail businesses</p>
        </div>
        <div className="bg-white backdrop-blur-sm border border-pink-400 p-8 rounded-lg hover:border-pink-500 transition-all hover:bg-pink-50 group shadow-md">
          <div className="flex items-center mb-4">
            <div className="bg-gradient-to-r from-pink-600 to-rose-600 p-3 rounded-full mr-4">
              <ShoppingBag size={28} className="text-white" />
            </div>
            <h3 className="text-2xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-pink-600 to-rose-600 group-hover:from-pink-700 group-hover:to-rose-700 transition-colors font-cursive">Pronto</h3>
          </div>
          <p className="text-pink-800 font-cursive">Quick-to-deploy AI solution for Shopify stores</p>
        </div>
        <div className="bg-white backdrop-blur-sm border border-cyan-400 p-8 rounded-lg hover:border-cyan-500 transition-all hover:bg-cyan-50 group shadow-md">
          <div className="flex items-center mb-4">
            <div className="bg-gradient-to-r from-cyan-600 to-teal-600 p-3 rounded-full mr-4">
              <Phone size={28} className="text-white" />
            </div>
            <h3 className="text-2xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-cyan-600 to-teal-600 group-hover:from-cyan-700 group-hover:to-teal-700 transition-colors font-cursive">Concierge</h3>
          </div>
          <p className="text-cyan-800 font-cursive">AI receptionist that handles calls 24/7</p>
        </div>
        <div className="bg-white backdrop-blur-sm border border-amber-400 p-8 rounded-lg hover:border-amber-500 transition-all hover:bg-amber-50 group shadow-md">
          <div className="flex items-center mb-4">
            <div className="bg-gradient-to-r from-amber-600 to-orange-600 p-3 rounded-full mr-4">
              <Wrench size={28} className="text-white" />
            </div>
            <h3 className="text-2xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-amber-600 to-orange-600 group-hover:from-amber-700 group-hover:to-orange-700 transition-colors font-cursive">Custom AI Builds</h3>
          </div>
          <p className="text-amber-800 font-cursive">Bespoke solutions for unique business needs</p>
        </div>
      </div>
    </SlideLayout>
  );
};

export default ProductLineupSlide;
